module.exports = __webpack_public_path__ + "static/media/040-bhutan.1808930f.svg";